/* eslint-disable */
// Had to disable eslint for the entire file because it was falky due to something
// wrong with our setup, it was failing to recognize that this file is being used
// and was complaining.
// TODO: FRONT-5920
import Toolbar from 'components/common/Toolbar/Toolbar';

/**
 * Examples of Toolbar.
 */

function ToolbarExamplePage(): JSX.Element {
  const leftItems = [<div>Left item 1</div>, <div>Left item 2</div>];
  const rightItems = [<div>Right item 1</div>, <div>Right item 2</div>];

  return (
    <section id="toolbar" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Toolbar</h1>
      <div className="ExamplesPage__Description">
        Toolbar is a component that presents a set of related components as a linear row. It takes a list of items and
        displays them in a single row, adding spacing around them. Items can either be provided in a single list (which
        will be laid out from left to right), or in two separate lists, one on the left side of the toolbar and the
        other on the right side.
      </div>
      <div className="ExamplesPage__ExampleRow">
        <h3>Toolbar with one set of items</h3>
        <Toolbar items={leftItems} />
      </div>
      <div className="ExamplesPage__ExampleRow">
        <h3>Toolbar with two set of items</h3>
        <Toolbar leftItems={leftItems} rightItems={rightItems} />
      </div>
    </section>
  );
}

export default ToolbarExamplePage;
